import React from 'react';
import { getFontFamily } from '../../../fonts';
import { ReaderBlock } from '../../Reader/core';
function getBorder({ borderColor }) {
    if (!borderColor) {
        return undefined;
    }
    return `1px solid ${borderColor}`;
}
export default function EmailLayoutReader(props) {
    var _e, _t, _y, _10, _11;
    const childrenIds = (_e = props.childrenIds) !== null && _e !== void 0 ? _e : [];
    return (React.createElement("div", { style: {
            backgroundColor: (_t = props.backdropColor) !== null && _t !== void 0 ? _t : '#F5F5F5',
            color: (_y = props.textColor) !== null && _y !== void 0 ? _y : '#262626',
            fontFamily: getFontFamily(props.fontFamily),
            fontSize: '16px',
            fontWeight: '400',
            letterSpacing: '0.15008px',
            lineHeight: '1.5',
            margin: '0',
            padding: '32px 0',
            minHeight: '100%',
            width: '100%',
        } },
        React.createElement("table", { align: "center", width: "100%", style: {
                margin: '0 auto',
                maxWidth: '600px',
                backgroundColor: (_10 = props.canvasColor) !== null && _10 !== void 0 ? _10 : '#FFFFFF',
                borderRadius: (_11 = props.borderRadius) !== null && _11 !== void 0 ? _11 : undefined,
                border: getBorder(props),
            }, role: "presentation", cellSpacing: "0", cellPadding: "0", border: 0 },
            React.createElement("tbody", null,
                React.createElement("tr", { style: { width: '100%' } },
                    React.createElement("td", null, childrenIds.map((childId) => (React.createElement(ReaderBlock, { key: childId, id: childId })))))))));
}
//# sourceMappingURL=EmailLayoutReader.js.map